export default __webpack_public_path__ + "static/media/accuterra_outdoors_imperial_m.dfe91f62.png";